import { computed, type ComputedRef } from 'vue';
import { storeToRefs } from 'pinia';
import { useOrganizationStore } from '@/store/useOrganizationStore';
import { useEntitlements } from '@/composables/useEntitlements';

export function useUserSeats() {
  const { seatsCount, seatsLeft } = storeToRefs(useOrganizationStore());
  const userLimit = useEntitlements().limit('users');

  const isAtUserLimit: ComputedRef<boolean> = computed(() => {
    const limitVal = userLimit.value;
    if (limitVal == null || limitVal < 0) {
      return false;
    }
    return seatsCount.value - seatsLeft.value >= limitVal;
  });

  return { isAtUserLimit, userLimit };
}
